<template>
  <main class="container container-choose-route d-flex flex-column align-items-center">
    <CustomerLoginComponent></CustomerLoginComponent>
  </main>
</template>

<script lang="ts">
// @ts-ignore
import CustomerLoginComponent from "../../components/CustomerLogIn/CustomerLogInComponent.vue";
import './logIn.scss';
import axios from "axios";
import apiService from "../../services/apiService";
import {useStore} from "vuex";
import {defineComponent} from "vue";

export default defineComponent({
  name: "LoginPage",
  components: {
    CustomerLoginComponent
  },
  setup() {
    const store = useStore();

    return {
      store
    }
  },
  data() {
    return {}
  },
  methods: {},
  created() {
    axios.get(apiService.pageLoginPageEndpoint())
        .then((response) => {})
        .catch(error => console.error(error));
  },
});
</script>